export default {
  // 主题色相关色号
  '--theme-color-primary': '#cb2b83',
  '--theme-color-hover': '#e0529c',
  '--theme-color-active': '#a02669',
  '--theme-color-disable': '#f8a8cc',
  // 文字类相关色号
  '--theme-text-primary': '#ffffff',
  '--theme-text-hover': '#111d2c',
  '--theme-text-secondary': '#494E56',
  '--theme-text-subsidiary': '#7A8088',
  '--theme-text-disable': '#C4C7CC',
  '--theme-text-link': '#cb2b83',
  '--theme-light': '#162312',
  '--theme-dark': '#FFFFFF',
  // 背景类相关色号
  '--theme-bg-white': '#23252d',
  '--theme-bg-gray': '#113536',
  '--theme-bg-hover': '#40162f',
  '--theme-bg-active': '#E5F1FF',
  '--theme-bg-dark': '#FFFFFF',
  // border类相关色号
  '--theme-border-color': '#DADCE0',
  // 分割线相关色号
  '--theme-divider-horizontal': '#F5F7FA',
  '--theme-divider-vertical': '#EBEDF0',
  // 反馈类相关色号
  '--theme-primary-border': '#96C4FF',
  '--theme-success': '#00C261',
  '--theme-success-bg': '#DEF7EA',
  '--theme-success-border': '#88E5B5',
  '--theme-warning': '#FF7700',
  '--theme-warning-bg': '#FFF0E5',
  '--theme-warning-border': '#FFC698',
  '--theme-error': '#FF2626',
  '--theme-error-bg': '#FFE5E6',
  '--theme-error-border': '#FFA3A5',

  // border-radius
  '--theme-border-radius-tiny': '2px',
  '--theme-border-radius-small': '4px',
  '--theme-border-radius-normal': '6px',
  '--theme-border-radius-big': '8px',
  '--theme-border-radius-large': '10px',

  // space
  '--theme-page-space': '16px', // 页面内间距
  '--theme-block-margin': '12px', // 页面容器、元素之间间距
  '--theme-block-padding': '20px', // 容器内间距

  // font
  '--theme-font-small': '12px',
  '--theme-font-normal': '14px',
  '--theme-font-large': '16px',
  '--theme-font-18': '18px',
  '--theme-font-20': '20px',
  '--theme-font-22': '22px',
  '--theme-font-24': '24px',
  '--theme-font-26': '26px',

  // font-weight
  '--theme-font-weight-semibold': '600',
  '--theme-font-weight-regular': '400',
};
